<template>
  <div>
    <div v-if="submitted">
      <h2 class="text-primary text-h1 mb-8 mt-60px text-center">
        Thank you for your interest!
      </h2>
      <p class="text-center">
        Someone from our team will reach out shortly.
      </p>
      <p class="text-center mb-3">
        Until then, continue shopping and follow us on Instagram <a href="https://www.instagram.com/elaluz/">@elaluz</a>!
      </p>
    </div>
    <form @submit.prevent="submit" v-if="!submitted">
      <!-- Affiliate Type -->
      <!-- General Info -->
      <!-- Extra Info -->
      <h2 v-if="!offerSetByScript" class="text-primary text-h2 content-title mb-3 pb-3" id="first-title">
        {{ 'Tell Us More About Yourself' }}
      </h2>
      <layout-single-column v-if="!offerSetByScript">
        <base-select
            class="col-xs-12 col-sm-6 mb25"
            name="offer"
            :id="'offer'"
            :options="offerOptions"
            :placeholder="'Choose Your Business Type to Continue'"
            v-model="formData.offer"
            :validations="[
              {
                condition: $v.formData.offer.$error && !$v.formData.offer.required,
                text: validateMessage('required', { attr: 'Business Type'})
              }
            ]"
        >
          Business Type <span>*</span>
        </base-select>
      </layout-single-column>

      <div class="main-form-wrapper">
        <div class="main-form-overlay" v-if="!formData.offer"/>
        <h2 class="text-primary text-h2 content-title mb-3 pb-3 mt-0 pt-0">
          {{ 'TELL US ABOUT YOURSELF' }}
        </h2>
        <layout-two-column>
          <template v-slot:first>
            <base-input
                :input-class="'text-black'"
                :placeholder="'First name'"
                autocomplete="given-name"
                name="first-name"
                type="text"
                v-model="formData.first_name"
                @blur="$v.formData.first_name.$touch()"
                :validations="[
                {
                  condition: $v.formData.first_name.$error && !$v.formData.first_name.required,
                  text: validateMessage('required', { attr: 'First name'})
                },
                {
                  condition: !$v.formData.first_name.minLength,
                  text: validateMessage('minLength', { attr: 'First name', min: 2 })
                }
              ]"
            >
              First name <span>*</span>
            </base-input>
          </template>
          <template v-slot:second>
            <base-input
                :input-class="'text-black'"
                :placeholder="'Last name'"
                autocomplete="family-name"
                name="last-name"
                type="text"
                v-model="formData.last_name"
                @blur="$v.formData.last_name.$touch()"
                :validations="[
                {
                  condition: $v.formData.last_name.$error && !$v.formData.last_name.required,
                  text: validateMessage('required', { attr: 'Last name'})
                },
                {
                  condition: !$v.formData.last_name.minLength,
                  text: validateMessage('minLength', { attr: 'Last name', min: 2 })
                }
              ]"
            >
              Last name <span>*</span>
            </base-input>
          </template>
        </layout-two-column>

        <layout-two-column>
          <template v-slot:first>
            <base-input
                :input-class="'text-black'"
                :placeholder="'Company'"
                name="company"
                v-model="formData.company"
                @blur="($v.formData.company) ? $v.formData.company.$touch() : () => {}"
                type="text"
                :validations="($v.formData.company) ? [
                {
                  condition: $v.formData.company.$error && !$v.formData.company.required,
                  text: validateMessage('required', { attr: 'Company' })
                },
                {
                  condition: !$v.formData.company.minLength,
                  text: validateMessage('minLength', { attr: 'Company', min: 3 })
                }
              ] : []"
            >
              Company {{ companyRequiredString }}
            </base-input>
          </template>
          <template v-slot:second>
            <base-input
                :input-class="'text-black'"
                :placeholder="'Phone'"
                autocomplete="tel"
                name="phone"
                type="text"
                @blur="$v.formData.phone.$touch()"
                v-model="formData.phone"
                :validations="[
                {
                  condition: $v.formData.phone.$error && !$v.formData.phone.required,
                  text: validateMessage('required', { attr: 'Phone'})
                },
                {
                  condition: !$v.formData.phone.minLength,
                  text: validateMessage('minLength', { attr: 'Phone', min: 5 })
                },
                {
                  condition: !$v.formData.phone.isPhone,
                  text: validateMessage('isPhone', { attr: 'Phone' })
                }
              ]"
            >
              Phone <span>*</span>
            </base-input>
          </template>
        </layout-two-column>

        <layout-single-column>
          <base-input
              :input-class="'text-black'"
              :placeholder="'Email'"
              autocomplete="email"
              name="email"
              v-model="formData.email"
              @blur="$v.formData.email.$touch()"
              type="email"
              :validations="[
                {
                  condition: $v.formData.email.$error && !$v.formData.email.required,
                  text: validateMessage('required', { attr: 'Email' })
                },
                {
                  condition: !$v.formData.email.email,
                  text: validateMessage('email', { attr: 'Email' })
                }
              ]"
          >
            Email <span>*</span>
          </base-input>
        </layout-single-column>

        <layout-single-column>
          <base-input
              :input-class="'text-black'"
              :placeholder="'Paypal Email'"
              autocomplete="mypaypalemail@example.com"
              name="paypal_email"
              v-model="formData.paypal_email"
              @blur="$v.formData.paypal_email.$touch()"
              type="text"
              :validations="[
                {
                  condition: $v.formData.paypal_email.$error && !$v.formData.paypal_email.required,
                  text: validateMessage('required', { attr: 'Paypal Email Address' })
                },
                {
                  condition: !$v.formData.paypal_email.email,
                  text: validateMessage('email', { attr: 'Paypal Email Address' })
                }
              ]"
          >
            Paypal Email Address <span>*</span>
          </base-input>
        </layout-single-column>

        <layout-two-column>
          <template v-slot:first>
            <base-input
                :input-class="'text-black'"
                :placeholder="'Password'"
                name="password"
                @blur="$v.formData.password.$touch()"
                @change="$v.formData.password.$touch()"
                v-model="formData.password"
                type="password"
                :validations="[
                {
                  condition: $v.formData.password.$error && !$v.formData.password.required,
                  text: validateMessage('required', { attr: 'Password' })
                },
                {
                  condition: !$v.formData.password.minLength,
                  text: validateMessage('minLength', { attr: 'Password', min: 9 })
                }
              ]"
            >
              {{ 'Password' }} <span>*</span>
            </base-input>
          </template>
          <template v-slot:second>
            <base-input
                :input-class="'text-black'"
                :placeholder="'Password Confirmation'"
                name="password_confirmation"
                @blur="$v.formData.password_confirmation.$touch()"
                @change="$v.formData.password_confirmation.$touch()"
                v-model="formData.password_confirmation"
                type="password"
                :validations="[
                {
                  condition: $v.formData.password_confirmation.$error && !$v.formData.password_confirmation.required,
                  text: validateMessage('required', { attr: 'Password Confirmation' })
                },
                {
                  condition: !$v.formData.password_confirmation.sameAsPassword && $v.formData.password_confirmation.$error,
                  text: 'Passwords must be identical.'
                }
              ]"
            >
              {{ 'Password Confirmation' }} <span>*</span>
            </base-input>
          </template>
        </layout-two-column>

        <h2 class="text-primary text-h2 content-title mb-3 pb-3 mt-2">
          {{ 'SHIPPING ADDRESS' }}
        </h2>
        <layout-single-column>
          <base-input
              :input-class="'text-black'"
              :placeholder="'Address Line 1'"
              autocomplete="address-line1"
              name="address1"
              v-model="formData.address1"
              @blur="$v.formData.address1.$touch()"
              type="text"
              :validations="[
                {
                  condition: $v.formData.address1.$error && !$v.formData.address1.required,
                  text: validateMessage('required', { attr: 'Address line 1' })
                },
                {
                  condition: !$v.formData.address1.minLength,
                  text: validateMessage('minLength', { attr: 'Address line 1', min: 5 })
                }
              ]"
          >
            Address Line 1 <span>*</span>
          </base-input>
        </layout-single-column>

        <layout-single-column>
          <base-input
              :input-class="'text-black'"
              :placeholder="'Address Line 2'"
              autocomplete="address-line2"
              name="address2"
              v-model="formData.address2"
              type="text"
          >
            {{ 'Address Line 2' }}
          </base-input>
        </layout-single-column>

        <layout-two-column>
          <template v-slot:first>
            <base-select
                name="countries"
                :id="'countries'"
                :options="countryOptions"
                :selected="formData.country"
                v-model="formData.country"
                autocomplete="country"
            >
              Country <span>*</span>
            </base-select>
          </template>
          <template v-slot:second>
            <base-select
                class="col-xs-12 col-sm-6 mb25"
                name="state"
                :id="'state'"
                :options="(formData.country === 'US') ? usaStateOptions : canadaStateOptions"
                :selected="formData.state"
                v-model="formData.state"
                autocomplete="country"
            >
              State/Province <span>*</span>
            </base-select>
          </template>
        </layout-two-column>

        <layout-two-column>
          <template v-slot:first>
            <base-input
                :input-class="'text-black'"
                :placeholder="'City'"
                autocomplete="address-level2"
                name="city"
                v-model="formData.city"
                @blur="$v.formData.city.$touch()"
                type="text"
                :validations="[
                {
                  condition: $v.formData.city.$error && !$v.formData.city.required,
                  text: validateMessage('required', { attr: 'City' })
                },
                {
                  condition: !$v.formData.city.minLength,
                  text: validateMessage('minLength', { attr: 'City', min: 5 })
                }
              ]"
            >
              City <span>*</span>
            </base-input>
          </template>
          <template v-slot:second>
            <base-input
                :input-class="'text-black'"
                :placeholder="'Postal/Zip Code'"
                autocomplete="postal-code"
                name="zip"
                v-model="formData.zip"
                @blur="$v.formData.zip.$touch()"
                type="text"
                :validations="[
                {
                  condition: $v.formData.zip.$error && !$v.formData.zip.required,
                  text: validateMessage('required', { attr: 'Postal/Zip code' })
                },
                {
                  condition: !$v.formData.zip.minLength,
                  text: validateMessage('minLength', { attr: 'Postal/Zip code', min: 3 })
                }
              ]"
            >
              Postal/Zip Code <span>*</span>
            </base-input>
          </template>
        </layout-two-column>



        <!--        <div v-if="getOfferType === 'stylist_salon'">
                  <h2 class="text-primary text-h2 content-title my-6 pb-3">
                    {{ 'Salon Information' }}
                  </h2>
                  <div class="flex flex-wrap -mx-3">
                    <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <base-input
                          :input-class="'text-black'"
                          :placeholder="'Salon Name'"
                          name="salon_name"
                          @blur="$v.formData.custom_67534.$touch()"
                          @change="$v.formData.custom_67534.$touch()"
                          v-model="formData.custom_67534"
                          type="text"
                          :validations="[
                          {
                            condition: $v.formData.custom_67534.$error && !$v.formData.custom_67534.required,
                            text: validateMessage('required', { attr: 'Salon Name' })
                          },
                          {
                            condition: !$v.formData.custom_67534.minLength,
                            text: validateMessage('minLength', { attr: 'Salon Name', min: 3 })
                          }
                        ]"
                      >
                        {{ 'Salon Name' }}
                      </base-input>
                    </div>
                    <div class="w-full md:w-1/2 px-3" />
                  </div>
                </div>-->

        <!--
        <div v-if="getOfferType === 'distributor'">
          <h2 class="text-primary text-h2 content-title my-6 pb-3">
            {{ 'Distributor Information') }}
          </h2>
          <div class="flex flex-wrap -mx-3">
            <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <base-input
                :input-class="'text-black'"
                :placeholder="'Distributor Sales Consultant Name'"
                name="dist_sales_consult_name"
                @blur="$v.formData.custom_67395.$touch()"
                @change="$v.formData.custom_67395.$touch()"
                v-model="formData.custom_67395"
                type="text"
              >
                {{ 'Distributor Sales Consultant Name') }}
              </base-input>
            </div>
            <div class="w-full md:w-1/2 px-3" />
          </div>
        </div>
        -->

        <h2 class="text-primary text-h2 content-title my-6 pb-3">
          {{ 'Additional Information' }}
        </h2>
        <layout-two-column>
          <template v-slot:first>
            <base-input
                :input-class="'text-black'"
                :placeholder="`Birthdate`"
                name="birthdate"
                v-model="formData.custom_76521"
                @blur="$v.formData.custom_76521.$touch()"
                type="date"
                :validations="[
                {
                  condition: $v.formData.custom_76521.$error && !$v.formData.custom_76521.required,
                  text: validateMessage('required', { attr: 'Birthdate' })
                }
              ]"
            >
              {{ 'Birthdate (must be over 18)' }} <span>*</span>
            </base-input>
          </template>
          <template v-slot:second>
            <base-input
                :input-class="'text-black'"
                :placeholder="'https://www.facebook.com/elaluz'"
                name="facebook"
                v-model="formData.custom_76523"
                @blur="$v.formData.custom_76523.$touch()"
                type="url"
            >
              {{ 'Facebook URL' }}
            </base-input>
          </template>
        </layout-two-column>
        <layout-two-column>
          <template v-slot:first>
            <base-input
                :input-class="'text-black'"
                :placeholder="'@elaluz'"
                name="instagram"
                required="required"
                v-model="formData.custom_76520"
                type="text"
                :validations="[
                {
                  condition: $v.formData.custom_76520.$error && !$v.formData.custom_76520.required,
                  text: validateMessage('required', { attr: 'Instagram' })
                }
              ]"
            >
              {{ 'Your Instagram (this will become your vanity link)' }} <span>*</span>
            </base-input>
          </template>
          <template v-slot:second>
            <base-input
                :input-class="'text-black'"
                :placeholder="'@elaluz'"
                name="tiktok"
                v-model="formData.custom_76522"
                type="text"
            >
              {{ 'Your Tiktok Handle' }}
            </base-input>
          </template>
        </layout-two-column>
        <layout-single-column>
          <base-text-area
              :input-class="'text-black'"
                         :placeholder="'www.example.com, youtube.com/mychannel'"
                         name="other_channels"
                         v-model="formData.custom_77378"
                         >
            {{ 'Do you have a website/blog, Youtube channel or other social channels you use?' }}
          </base-text-area>
        </layout-single-column>
        <layout-single-column>
          <base-text-area
              :input-class="'text-black'"
              name="other_info"
              v-model="formData.custom_77504"
          >
            {{ 'Anything else you want us to know about you?' }}
          </base-text-area>
        </layout-single-column>

<!--        <layout-two-column>
          <template v-slot:first>
            <base-input
                :input-class="'text-black'"
                :placeholder="'https://www.example.com'"
                name="website"
                v-model="formData.custom_68652"
                type="url"
            >
              {{ 'Your Website' }}
            </base-input>
          </template>
          <template v-slot:second></template>
        </layout-two-column>-->


        <!--<div class="flex flex-wrap -mx-3 mt-2">
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <base-select
              class="col-xs-12 col-sm-6 mb25"
              name="igFollowerCount"
              :id="'igFollower'"
              :options="followerOptions"
              :placeholder="'How many followers do you have?')"
              v-model="formData.custom_67390"
            >
              {{ 'Instagram Followers') }}
            </base-select>
          </div>
          <div class="w-full md:w-1/2 px-3">
            <base-select
              class="col-xs-12 col-sm-6 mb25"
              name="igFollowerCount"
              :id="'tiktokFollower'"
              :options="followerOptions"
              :placeholder="'How many followers do you have?')"
              v-model="formData.custom_68112"
            >
              {{ 'Tiktok Followers') }}
            </base-select>
          </div>
        </div>-->

        <h2 class="text-primary text-h2 content-title my-6 pb-3">
          {{ 'Legal' }}
        </h2>
        <layout-single-column>
          <base-checkbox
              id="terms"
              @click="formData.custom_77313 = !formData.custom_77313"
              @blur="$v.formData.custom_77313.$touch()"
              @change="$v.formData.custom_77313.$touch()"
              v-model="formData.custom_77313"
              :validations="[
                {
                  condition: $v.formData.custom_77313.$error && !$v.formData.custom_77313.sameAs,
                  text: validateMessage('sameAs', { attr: 'You must agree to our terms and conditions.' })
                }
              ]"
          >
            <span>By checking this you agree to our <a class="font-bold" target="_blank" href="/pages/affiliates-legal">terms and conditions</a>.<span>*</span></span>
          </base-checkbox>
        </layout-single-column>
        <layout-single-column>
          <base-checkbox
              id="smsTerms"
              @click="smsAccept = !smsAccept"
              @blur="$v.smsAccept.$touch()"
              @change="$v.smsAccept.$touch()"
              v-model="smsAccept"
              :validations="[
                {
                  condition: $v.smsAccept.$error && !$v.smsAccept.sameAs,
                  text: validateMessage('sameAs', { attr: 'You must agree to our SMS terms and privacy.' })
                }
              ]"
          >

            <span>
              <strong class="uppercase">Sign Up For Texts.</strong><br>
              By checking this box, you agree to receive recurring automated promotional and personalized marketing
            text messages (e.g. cart reminders) from Elaluz at the cell number used when signing up. Consent is not a
            condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies.
              Msg and data rates may apply. View <a class="font-bold" target="_blank" href="http://attn.tv/elaluz/terms.html">Terms</a>
              & <a class="font-bold" target="_blank" href="https://attnl.tv/p/L0O">Privacy</a>.<span>*</span></span>
          </base-checkbox>
        </layout-single-column>
        <div class="mt-6">
          <button-outline class=" w-full md:w-1/3" :type="'submit'" :color="'primary'">
            {{ 'Submit' }}
          </button-outline>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {required, minLength, email, sameAs} from 'vuelidate/lib/validators'
import BaseCheckbox from './BaseCheckbox.vue'
import BaseInput from './BaseInput.vue'
import BaseTextArea from './BaseTextArea.vue'
import BaseSelect from './BaseSelect.vue'
import ButtonOutline from './ButtonOutline.vue'
import validateMessage from '../helpers/validateMessage.js'
import {validationMixin} from 'vuelidate'
import {isPhone} from '@/helpers/validationRules'
import {httpClient} from '@/helpers/httpClient'
import LayoutTwoColumn from "@/components/LayoutTwoColumn";
import LayoutSingleColumn from "@/components/LayoutSingleColumn";

export default {
  name: 'AffiliateRegister',
  components: {
    LayoutSingleColumn,
    LayoutTwoColumn,
    BaseInput,
    BaseSelect,
    ButtonOutline,
    BaseCheckbox,
    BaseTextArea
  },
  props: {},
  data() {
    return {
      offerSetByScript: false,
      smsAccept: false,
      offers: {
        "types": {
          "influencer": [
            "95940",
          ]
        },
        "offers": {
          "Influencer - Creator": "95940"
        }
      },
      current: false,
      submitted: false,
      countries: {
        'US': 'United States',
        'CA': 'Canada'
      },
      usaStates: {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AS': 'American Samoa',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District Of Columbia',
        'FM': 'Federated States Of Micronesia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'GU': 'Guam',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MH': 'Marshall Islands',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'MP': 'Northern Mariana Islands',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PW': 'Palau',
        'PA': 'Pennsylvania',
        'PR': 'Puerto Rico',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VI': 'Virgin Islands',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming'
      },
      canadaStates: {
        'AB': 'Alberta',
        'BC': 'British Columbia',
        'MB': 'Manitoba',
        'NB': 'New Brunswick',
        'NL': 'Newfoundland and Labrador',
        'NT': 'Northwest Territories',
        'NS': 'Nova Scotia',
        'NU': 'Nunavut',
        'ON': 'Ontario',
        'PE': 'Prince Edward Island',
        'QC': 'Quebec',
        'SK': 'Saskatchewan',
        'YT': 'Yukon Territory'
      },
      followerOptions: [
        {
          label: '0 - 5,000',
          value: '0 - 5,000'
        },
        {
          label: '5,000 - 10,000',
          value: '5,000 - 10,000'
        },
        {
          label: '20,000 - 50,000',
          value: '20,000 - 50,000'
        },
        {
          label: '50,000+',
          value: '50,000+'
        }
      ],
      formData: {
        offer: '',
        first_name: '',
        last_name: '',
        company: '',
        phone: '',
        email: '',
        address1: '',
        address2: '',
        zip: '',
        postal_code: '',
        country: 'US',
        state: 'AL',
        password: '',
        password_confirmation: '',
        unique_merchant_id: '',
        paypal_email: '',
        // 'custom_67534': '', // Salon Name
        // 'custom_67394': '', // Distributor Name
        // 'custom_67395': '', // Distributor Sales Consultant Name
        'custom_76520': '', // Instagram
        // 'custom_67390': '', // Number of IG Followers
        'custom_76522': '', // Tiktok Handle
        //'custom_68112': '', // Tiktok followers
        // 'custom_68652': '', // Website
        'custom_77313': false, // Agree to terms,
        'custom_76521': '', // birthdate
        'custom_76523': '', // facebook
        'custom_77378': '', // other channles
        'custom_77504': '', // other info
        'custom_79110': '', // accept terms date
      }
    }
  },
  validations() {
    let validationsData = {
      smsAccept: {
        required,
        sameAs: sameAs( () => true )
      },
      formData: {
        offer: {
          required
        },
        first_name: {
          required,
          minLength: minLength(2)
        },
        last_name: {
          required,
          minLength: minLength(2)
        },
        phone: {
          required,
          minLength: minLength(5),
          isPhone
        },
        password: {
          required,
          minLength: minLength(9)
        },
        password_confirmation: {
          required,
          sameAsPassword: sameAs('password')
        },
        email: {
          required,
          email,
          minLength: minLength(5)
        },
        paypal_email: {
          required,
          email,
          minLength: minLength(5)
        },
        address1: {
          required,
          minLength: minLength(5)
        },
        address2: {},
        city: {
          required,
          minLength: minLength(3)
        },
        zip: {
          required,
          minLength: minLength(3)
        },
        custom_77313: { // terms
          required,
          sameAs: sameAs( () => true )
        },
        custom_76520: { // instagram
          required
        },
        custom_76521: { // birth date
          required
        },
      }
    }

    // if (this.getOfferType === 'salon' ||
    //     this.getOfferType === 'salon_direct' ||
    //     this.getOfferType === 'distributor') {
    //   validationsData.formData.company = {
    //     required,
    //     minLength: minLength(3)
    //   };
    // }
    //
    // if (this.getOfferType === 'stylist_salon') {
    //   // Salon Name
    //   validationsData.formData.custom_67534 = {
    //     required,
    //     minLength: minLength(3)
    //   }
    // }

    //if (this.getOfferType === 'distributor') {
    // distributor name
    // validationsData.formData.custom_67394 = {
    //   required,
    //   minLength: minLength(3)
    // }
    //
    // // distributor sales consultant name
    // validationsData.formData.custom_67395 = {
    //   required,
    //   minLength: minLength(3)
    // }
    // }

    return validationsData
  },
  created() {
  },
  mounted() {
    let offers = this.offers.offers
    let keys = Object.keys(offers)
    if (keys.length === 1) {
      this.formData.offer = offers[keys[0]]
      this.offerSetByScript = true;
    }

    window.LBPLegal = window.LBPLegal || {}
    window.LBPLegal.affiliateConsentId = window.LBPLegal.affiliateConsentId || '4/13/2022'
    if (window.LBPLegal.affiliateConsentId) {
      this.formData.custom_79110 = window.LBPLegal.affiliateConsentId
    }
  },
  computed: {
    companyRequiredString: function () {
      return (this.$v.formData.company ? '*' : '')
    },
    countryOptions: function () {
      return Object.keys(this.countries).map((el) => {
        return {label: this.countries[el], value: el}
      })
    },
    usaStateOptions: function () {
      return Object.keys(this.usaStates).map((el) => {
        return {label: this.usaStates[el], value: el}
      })
    },
    canadaStateOptions: function () {
      return Object.keys(this.canadaStates).map((el) => {
        return {label: this.canadaStates[el], value: el}
      })
    },
    offerOptions: function () {
      let data = this.offers || {};
      let results = [];
      for (const key in (data.offers || {})) {
        // eslint-disable-next-line no-prototype-builtins
        if (data.offers.hasOwnProperty(key)) {
          results.push({
            label: key, value: data.offers[key]
          })
        }
      }
      return results
    },
    getOfferType: function () {
      let data = this.offers || {};
      for (const key in (data.types || {})) {
        // eslint-disable-next-line no-prototype-builtins
        if (data.types.hasOwnProperty(key)) {
          if (data.types[key].includes(this.formData.offer)) {
            return key
          }
        }
      }
      return null
    },
    isSalon: function () {
      return this.getOfferType === 'salon' ||
          this.getOfferType === 'salon_direct' ||
          this.getOfferType === 'distributor'
    }
  },
  methods: {
    submit() {
      this.$v.$touch()

      let formData = Object.assign({}, this.formData)

      if (formData.country === 'US') {
        formData['state-' + formData.country] = formData.state
      }

      let bodyFormData = new FormData()

      for (let key in formData) {
        if (formData[key] === null || formData[key] === '') continue;
        bodyFormData.append(key, formData[key])
      }

      if (this.$v.$invalid) {
        // Notification
        this.$v.$touch();
        this.scrollToError()
      } else {
        // this.submitted = true
        httpClient.post('https://affiliates.elaluz.com/api/v1/registerAdvance', bodyFormData).then((response) => {
          console.log(response)
          // handle success
          if (response.data.id) {
            this.submitted = true
            window.scrollTo(0, 0)
          }
        }).catch((error) => {
          if (error.response.data.errors) {
            for (let i = 0; i < error.response.data.errors.length; i++) {
              window.alert(error.response.data.errors[i]);
            }
            return
          }

          for (const key in error.response.data) {
            window.alert(key + ':' + error.response.data[key]);
          }
        })
      }
    },
    scrollToError() {
      setTimeout(() => {
        let errors = document.querySelectorAll('.errorMessage');
        if (errors && errors.length) {
          let top = window.pageYOffset + errors[0].getBoundingClientRect().top - 300;
          window.scrollTo({
            top: top,
            left: 0,
            behavior: 'smooth'
          })
        }
      }, 100)
    }
  },
  mixins: [validateMessage, validationMixin]
}
</script>

<style lang="scss">
img {
  border-width: 0;
  border-style: none;
}
</style>

<style lang="scss" scoped>
@import "../assets/css/output.css";
body {
}

base-input {
  @apply md:mt-3.5
}

base-select {
  @apply md:mt-3.5
}

form {
  position: relative;
}

#first-title {
  margin-top: 0;
}

.content-title {
  position: relative;
  text-align: center;
  font-size: 30px !important;
  margin-top: 1rem;
  text-transform: uppercase;
  margin-bottom: 0;
  font-family: 'Beauford-Light', sans-serif;

  @media screen and (min-width: 768px) {
    text-align: left;
  }

  &:before {
    display: none;
    content: "";
    position: absolute;
    width: 25px;
    height: 2px;
    bottom: 0;
    left: 0;
    border: solid 1px;
  }
}

.main-form-wrapper {
  @apply relative;
}

.main-form-overlay {
  @apply absolute h-full w-full z-10;
}

/*
  setting color + opacity on overlay itself doesn't work with the different color
  backgrounds between R+Co and Bleu
 */
.main-form-overlay ~ * {
  opacity: 0.5;
}
</style>
